import React, { FC } from 'react';

import { ReferralUser as ReferralUserModel } from 'api-client';
import { DataTable, Skeleton } from 'components/common';
import { PaginationLoadMore } from 'components/pagination';

import { ReferralUserMobileCard } from '../ReferralUserMobileCard';
import { ReferralUserTableRow } from '../ReferralUserTableRow';
import styles from './ReferralUserList.module.scss';

interface Props {
  users: ReferralUserModel[];
  loading: boolean;
  page: number;
  totalCount: number;
  onLoadMore: () => void;
  onReset: () => void;
}

const TABLE_COLUMNS = '1.8fr 1fr 1fr 0.6fr 1.2fr 130px';
const SKELETON_ITEMS_COUNT = 5;

const ReferralUserList: FC<Props> = ({ users, loading, page, totalCount, onLoadMore, onReset }) => {
  const isEmpty = users.length === 0;
  const isInitialLoading = loading && isEmpty;
  // PaginationLoadMore прячется сам, когда показан весь список с первой страницы,
  // поэтому подложку под кнопку в этом случае тоже не рисуем.
  const showLoadMore = users.length < totalCount || page > 1;

  return (
    <div className={styles.list}>
      <div className={styles.title}>Список приглашенных инвесторов</div>
      <div className={styles.surface}>
        {isInitialLoading ? (
          <div className={styles.skeletons}>
            {Array.from({ length: SKELETON_ITEMS_COUNT }).map((_, index) => (
              <Skeleton key={index} height="3.5rem" />
            ))}
          </div>
        ) : (
          <>
            <div className={styles.desktop}>
              <DataTable variant="surface" columns={TABLE_COLUMNS} className={styles.table}>
                <DataTable.Head>
                  <DataTable.HeadCell>Инвестор</DataTable.HeadCell>
                  <DataTable.HeadCell>Дата регистрации</DataTable.HeadCell>
                  <DataTable.HeadCell>Ставка дохода</DataTable.HeadCell>
                  <DataTable.HeadCell align="center">Сделок</DataTable.HeadCell>
                  <DataTable.HeadCell>Всего начислено</DataTable.HeadCell>
                  <DataTable.HeadCell />
                </DataTable.Head>
                <DataTable.Body>
                  {isEmpty ? (
                    <DataTable.Empty>Приглашенные инвесторы не найдены</DataTable.Empty>
                  ) : (
                    users.map((user) => <ReferralUserTableRow user={user} key={user.uuid} />)
                  )}
                </DataTable.Body>
              </DataTable>
            </div>
            <div className={styles.mobile}>
              {isEmpty ? (
                <div className={styles.empty}>Приглашенные инвесторы не найдены</div>
              ) : (
                users.map((user) => <ReferralUserMobileCard user={user} key={user.uuid} />)
              )}
            </div>
            {showLoadMore && (
              <div className={styles.footer}>
                <PaginationLoadMore
                  loaded={users.length}
                  total={totalCount}
                  page={page}
                  loading={loading}
                  onLoadMore={onLoadMore}
                  onReset={onReset}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ReferralUserList;
